/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from "./vuetify";
import pinia from "../stores";
import router from "../router";

// Types
import type { App } from "vue";
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  "locale": "de",
  "messages": {
    de: {
      numberFormat: new Intl.NumberFormat("de-DE")
    }
  },
  "de-DE": {
    currency: {
      style: "currency",
      currency: "EUR",
      notation: "standard",
      currencyDisplay: "symbol"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    percent: {
      style: "percent",
      useGrouping: false
    }
  }
});

export function registerPlugins(app: App) {
  app.use(vuetify).use(router).use(pinia).use(i18n);
}
